import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import ColorMap from "./ColorMap";
import Color from "terriajs-cesium/Source/Core/Color";
export default class EnumColorMap extends ColorMap {
  constructor(options) {
    super();
    _defineProperty(this, "values", void 0);
    _defineProperty(this, "colors", void 0);
    _defineProperty(this, "nullColor", void 0);
    this.nullColor = Color.clone(options.nullColor);
    const values = [];
    const colors = [];
    options.enumColors.forEach(bin => {
      values.push(bin.value);
      colors.push(Color.clone(bin.color));
    });
    this.values = values;
    this.colors = colors;
  }
  mapValueToColor(value) {
    if (value === undefined || value === null) {
      return this.nullColor;
    } else if (typeof value !== "string") {
      value = value.toString();
    }
    const values = this.values;
    for (let i = 0, len = values.length; i < len; ++i) {
      if (values[i] === value) {
        return this.colors[i];
      }
    }
    return this.nullColor;
  }
}